import { useContext } from 'react';
import { appRefContext } from './context';

export const useAppRef = () => {
  const appRef = useContext(appRefContext);
  return appRef;
};
